/**
 * Angular imports.
 */
import { Component, Input } from '@angular/core';

/**
 * Modal imports.
 */
import { BreadCrumb } from '../../onboarding/interface/global.model';

/**
 * sed to show the breadcrumbs.
 */
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {

  /**
   * List of available breadcrumbs.
   */
  @Input() breadcrumb: BreadCrumb[] = [];
}
